import React, { useState} from "react";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi";
import axios from 'axios';
import { Navigate } from "react-router-dom";
import ImageUpload from "../../components/imageUpload.js";



const PlayerCreate = ()=>{
     const [name, setName ] = useState('');
     const [mobileNo, setMobileNo ] = useState('');
     const [regDate, setRegDate ] = useState('');
     const [transDate, setTransDate ] = useState('');
     const [status, setStatus ] = useState('');
     const [regType, setRegType ] = useState('');
     const [redirect, setRedirect] = useState(false);
     const submit = async (e)=>{
          // get current time in HH:mm:ss format
        const now = new Date();
        const currentTime = now.toTimeString().split(" ")[0]; // e.g. "14:23:45"

        const formattedRegDate = `${regDate}T${currentTime}`;
        const formattedTransDate = `${transDate}T${currentTime}`;

         e.preventDefault();
         const {data} = await axios.post('player', {
            name,
            mobile_no:mobileNo,
            reg_date:formattedRegDate,
            trans_date:formattedTransDate,
            status,
            reg_type:regType,
        });
        console.log(data);
        setRedirect(true);
     }
    if(redirect){
        return <Navigate to={'/player'} />
    }
     return (
         <Wrapper pageTitle={"New Player"}>
            <InnerNav createLink={'/playerCreate'} listLink={'/player'} />
             <form onSubmit={submit}>
                <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800" >
                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Name </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Name"
                        onChange = {e => setName(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">MobileNo </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="MobileNo"
                        onChange = {e => setMobileNo(e.target.value)} />
                    </label>

                   <label className="block text-sm">
                    <span className="text-gray-700 dark:text-gray-400">RegDate</span>
                    <input
                        type="date"
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input"
                        placeholder="RegDate"
                        onChange={e => setRegDate(e.target.value)}
                    />
                    </label>

                  <label className="block text-sm">
                    <span className="text-gray-700 dark:text-gray-400">TransDate</span>
                    <input
                        type="date"
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input"
                        placeholder="TransDate"
                        onChange={e => setTransDate(e.target.value)}
                    />
                    </label>

                   <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Status</span>
                        <select
                            className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-select"
                            onChange={e => setStatus(e.target.value)}
                            defaultValue=""
                        >
                            <option value="" disabled>Select status</option>
                            <option value="Active">ACTIVE</option>
                            <option value="Inactive">Inactive</option>
                        </select>
                    </label>

                 <label className="block text-sm">
                    <span className="text-gray-700 dark:text-gray-400">RegType</span>
                    <select
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-select"
                        onChange={e => setRegType(e.target.value)}
                        defaultValue=""
                    >
                        <option value="" disabled>Select registration type</option>
                        <option value="INDIVIDUAL">INDIVIDUAL</option>
                        <option value="NONINDIVIDUAL">NONINDIVIDUAL</option>
                    </select>
                </label>

                    <div className="flex mt-6 text-sm">
                        <label className="flex items-center dark:text-gray-400">
                        <button className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                        onClick={submit}
                        > <FiSave /> <span className="ml-3">Save</span> </button>
                        </label>
                    </div>
                </div>
             </form>
        </Wrapper>
     );
};
export default PlayerCreate;
